import { FC } from 'react';

import { Stack } from '@mui/material';

import { AllVestaAssets } from '~config/types';

import { AssetIcon } from '.';

export const OverlappedAssetIcons: FC<{
  assets: AllVestaAssets[];
  iconSize: number;
  fullGradient?: boolean;
  noBg?: boolean;
  noBorder?: boolean;
}> = ({ assets, iconSize, fullGradient, noBg, noBorder }) => {
  return (
    <Stack direction={'row'} spacing={-1.2}>
      {assets.map((asset, index) => (
        <AssetIcon
          noBg={noBg}
          noBorder={noBorder}
          zIndex={assets.length - (index + 1) * 2}
          asset={asset}
          fullGradient={fullGradient}
          size={iconSize}
          round
          key={asset}
        />
      ))}
    </Stack>
  );
};
